'use client';

import { useEffect } from 'react';

export function ServiceWorkerRegister() {
  useEffect(() => {
    // Register service worker only in production and if supported
    if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
      navigator.serviceWorker.register('/sw.js', {
        scope: '/',
      }).then(() => {
        console.log('Service Worker registered successfully');
      }).catch((error) => {
        console.log('Service Worker registration failed:', error);
      });
    }
  }, []);

  return null;
}
